import { CellContext } from "@tanstack/react-table";
import { useState } from "react";

import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { glyphs, colors } from "../../../Styles";
import { IdentifiableRow } from "../reactiveTableRenderer";
import CheckBox, { CheckStyles } from "../../BaseComponents/checkBox";

export const CheckboxTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, cell}: CellContext<T, boolean | undefined> & EditAbleCell) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);
  const onChange = (e: boolean) => {
    setValue(e)
    if (e !== initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, e, row)
    }
  }
  return <StyledCheckboxCell staticColumn={staticColumn} key={cell.id} keyPass={cell.id+"Input"} onChange={onChange} canEdit={canEdit} cellData={{value}} />
}

const StyledCheckboxCell = ({onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5 }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      );
    } else {
      return <CheckBox disabled={cellData.static}
      isChecked={cellData.value as boolean}
      onChange={onChange}
      checkStyle={CheckStyles.transparent}
      key={keyPass}
    />
    }
  }

  return (
    <div style={{ position: "relative" }} key={keyPass}>
      {cellData.value ? (
        <div style={{position: "absolute", top: "50%", left: "10px", transform: "translate(-50%, -50%)"}}>
          <glyphs.Check key={keyPass} fillColor={colors.systemGreen}/>
        </div>
      ) : null}
    </div>
  );

}